import React from 'react';
import cn from 'classnames';

import { IIconButtonProps } from './IconButton.types';

import Tooltip from '../Tooltip';

import './IconButton.scss';

const IconButton: React.FC<IIconButtonProps> = ({
	tooltipLabel,
	icon: Icon,
	onClick,
	isActive,
	isDisabled,
	isFillPath,
	isRound,
	isWithoutShadow,
	...rest
}) => {
	const className = cn('f5gIconButtonWrapperIcon', {
		'f5gIconButtonWrapperActive': isActive && !isDisabled,
		'f5gIconButtonWrapperDisabled': isDisabled,
		'f5gIconButtonWrapperFillPath': isFillPath,
		'f5gIconButtonWrapperRound': isRound,
		'f5gIconButtonWrapperWithoutShadow': isWithoutShadow,
	});

	const props = {
		isActive,
		isDisabled,
		className,
		...rest,
		innerSvgProps: {
			className,
		},
	};

	const onClickHandler = () => {
		if (isDisabled || !onClick) return;

		onClick();
	};

	return (
		<Tooltip
			content={tooltipLabel}
			isDisabled={!tooltipLabel}
		>
			<div
				className='f5gIconButtonWrapper'
				data-testid='f5g-icon-button-wrapper'
				onClick={onClickHandler}
			>
				{Icon(props)}
			</div>
		</Tooltip>
	);
};

export default IconButton;
